import React, { useState, useEffect, useRef } from "react";
import {
  View,
  StyleSheet,
  Text,
  Keyboard,
  TouchableOpacity,
} from "react-native";

import { actions } from "@reducers/cartReducer";
import { useSelector, useDispatch, connect } from "react-redux";
import { actions as customerActions } from "@reducers/customerReducer";
import analytics from "@services/analytics";
import { ORDER_FLOW_EVENTS, CUSTOMER_PAGE } from "@constants/analyticsEventsCT";
import t from "@constants/localization";
import ModalLoader from "../../components/ModalLoader";
import { Header } from "../../components/Customer/Header";

import { CustomTextInput } from "../../components/Customer/TextInput";
import { scale, verticalScale } from "../../utils/scale";
import color from "../../constants/color";
import { createTlUser, addToCart } from "../../services/api";

const PATH = "screens/Customer/AddCustomer";

let fromCustomer;
let sku_id;
class AddCustomer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      mobile: "",
      allUsers: [],
      no: [],
      isLoading: false,
    };
  }

  shouldDisableSubmitBtn = () => {
    return this.state.name.length < 1 || this.state.mobile.length < 10;
  };

  addCart = (sku_id, cust_id, cb = () => {}) => {
    const apiPayload = {
      userId: cust_id,
      quantity: 1,
      skuId: sku_id,
    };

    addToCart(apiPayload)
      .then(({ data }) => {
        try {
          this.props.viewCartLiteSuccess(data, apiPayload.userId);

          this.setState({ isLoading: false });
        } catch (error) {
          console.log(error);
          this.setState({ isLoading: false });
          // alert(error)
        }
        this.setState({ isLoading: false });
        cb();
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  };

  componentDidMount() {
    try {
      sku_id = this.props.route.params?.sku_id ?? false;
      fromCustomer = this.props.route.params?.fromCustomer ?? false;
    } catch (error) {}
  }

  addUserApi = () => {
    Keyboard.dismiss();

    this.setState({ isLoading: true });
    const body = {
      priority: 1,
      user_id: this.state.mobile,
      name: this.state.name,
      phone_number: this.state.mobile,
    };
    createTlUser({ userCreds: body })
      .then((response) => {
        try {
          if (response.status === 200) {
            body.user_id = response.data.user_id;

            if (sku_id) {
              this.addCart(sku_id, response.data.user_id, () => {
                if (fromCustomer) {
                  this.props.navigation.navigate("Customers");
                } else {
                  this.props.setSelectedCustomer({
                    user_id: response.data.user_id,
                    user_name: this.state.name,
                    user_phone: this.state.mobile,
                  });

                  this.props.navigation.navigate("Home");
                }
              });
            } else {
              if (fromCustomer) {
                this.props.navigation.navigate("Customers");
              } else {
                this.props.setSelectedCustomer({
                  user_id: response.data.user_id,
                  user_name: this.state.name,
                  user_phone: this.state.mobile,
                });

                this.props.navigation.navigate("Home");
              }
              this.setState({ isLoading: false });
            }

            analytics.trackEvent(ORDER_FLOW_EVENTS.NEW_CX_ADDED, {
              source: "Manually",
            });
          }
        } catch (error) {
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        console.log(error);
      });
  };

  render() {
    return (
      <View style={{ flex: 1 }}>
        <ModalLoader loading={this.state.isLoading} />
        <Header
          onBackClick={() => this.props.navigation.goBack()}
          title={t(`${PATH}/addNewCustomer`)}
        />
        <CustomTextInput
          onChangeText={(text) =>
            this.setState({
              name: text
                .replace(
                  /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
                  "",
                )
                ?.trimLeft(),
            })
          }
          placeholder={t(`${PATH}/typeHere`)}
          title={t(`${PATH}/name`)}
          value={this.state.name}
        />
        <CustomTextInput
          maxLength={10}
          keyboardType="numeric"
          onChangeText={(text) => this.setState({ mobile: text?.trimLeft() })}
          value={this.state.mobile}
          placeholder={t(`${PATH}/typeHere`)}
          title={t(`${PATH}/mobileNo`)}
        />
        {!this.shouldDisableSubmitBtn() ? (
          <TouchableOpacity
            onPress={() => this.addUserApi()}
            style={styles.btnContainer}
          >
            <Text style={styles.btnText}>{t(`${PATH}/addCustomer`)}</Text>
          </TouchableOpacity>
        ) : (
          <View style={styles.disabledBtnContainer}>
            <Text style={styles.btnText}>{t(`${PATH}/addCustomer`)}</Text>
          </View>
        )}
      </View>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  toggleCartFetching: (data) => dispatch(actions.toggleCartFetching()),
  setSelectedCustomer: (data) =>
    dispatch(customerActions.setSelectedContact(data)),
  viewCartLiteRequest: (data) => dispatch(actions.viewCartLiteRequest(data)),
  viewCartLiteSuccess: (data, user_id) =>
    dispatch(actions.viewCartLiteSuccess(data, user_id)),
});
function mapStateToProps(state) {
  return {
    fetching: state.cart.fetching,
  };
}
export default connect(null, mapDispatchToProps)(AddCustomer);
const styles = StyleSheet.create({
  disabledBtnContainer: {
    width: scale(330),
    alignSelf: "center",
    height: verticalScale(54),
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    borderRadius: 10,
    position: "absolute",
    bottom: verticalScale(20),
    justifyContent: "center",
    alignItems: "center",
  },
  btnContainer: {
    width: scale(330),
    alignSelf: "center",
    height: verticalScale(54),
    backgroundColor: color.primary,
    borderRadius: 10,
    position: "absolute",
    bottom: verticalScale(20),
    justifyContent: "center",
    alignItems: "center",
  },
  btnText: {
    fontSize: scale(20),
    lineHeight: scale(28),
    color: color.white,
    fontWeight: "600",
  },
});
